module.exports = __webpack_public_path__ + "static/access israel-6d868bdd25f8e13e34acd2d33c189742.png";